<div class="flex flex-col items-center space-y-6 p-6 max-w-md mx-auto">
    <!-- Warning Icon -->
    <div class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
      <i class="pi pi-exclamation-triangle text-red-600 text-2xl"></i>
    </div>
    
    <!-- Title and Description -->
    <div class="text-center">
      <h3 class="text-lg font-semibold text-gray-900 mb-2">Delete Account</h3>
      <p class="text-sm text-gray-600 mb-4">
        For security reasons, we need to verify your identity before deleting your account.
      </p>
      <p class="text-sm text-gray-500">
        We've sent a verification code to <strong>{{ phoneNumber() }}</strong>
      </p>
    </div>
    
    <!-- OTP Input -->
    <div class="w-full">
      <label class="block text-sm font-medium text-gray-700 mb-2 text-center">
        Enter Verification Code
      </label>
      <p-inputotp 
        appNumericInputMode 
        inputmode="numeric" 
        [formControl]="otp" 
        [length]="6"
        [integerOnly]="true" 
        [autofocus]="true"
        [style]="{'justify-content': 'center'}" />
    </div>
    
    <!-- Messages -->
    @if (errorMessage()) {
      <p-message severity="error" [text]="errorMessage()" styleClass="w-full"></p-message>
    }
    
    @if (successMessage()) {
      <p-message severity="success" [text]="successMessage()" styleClass="w-full"></p-message>
    }
    
    <!-- Loading State -->
    @if (isLoading()) {
      <div class="flex items-center justify-center space-x-2 text-blue-600">
        <i class="pi pi-spin pi-spinner"></i>
        <span class="text-sm">Processing...</span>
      </div>
    }
    
    <!-- Action Buttons -->
    <div class="flex space-x-3 w-full">
      <p-button 
        label="Cancel" 
        [text]="true" 
        severity="primary"
        (onClick)="closeModal()"
        [disabled]="isLoading()"
        styleClass="flex-1">
      </p-button>
      
      <p-button 
        label="Verify & Delete" 
        severity="danger"
        (onClick)="verifyOTPAndDeleteAccount()"
        [loading]="isLoading()"
        [disabled]="!otp.valid || isLoading()"
        styleClass="flex-1">
      </p-button>
    </div>
    
    <!-- Resend Code -->
    <div class="text-center">
      <button 
        type="button" 
        class="text-sm text-blue-600 hover:text-blue-800 underline"
        (click)="sendVerificationCode()"
        [disabled]="isLoading()">
        Resend verification code
      </button>
    </div>
</div>
